import React, { useEffect, useState } from "react"
import labels from "./const"
import useLabels from "../../utils/useLabels"
import { Col, Row, Container, Button } from "reactstrap"

import * as s from "./style.module.css"
import { StaticImage } from "gatsby-plugin-image"

function Hero2025({ lang, type }) {
  const t = useLabels(labels, lang)

  return (
    <div className={s.heroImgWrapper}>
      <StaticImage className={s.heroImg} alt="Hackathon Hack4Change" src="images/h4c2026.webp" placeholder="blurred" />
      <a className={s.heroButton} href="https://app.evenea.pl/event/hack4change2026/" target="_blank">
        <Button
          color="primary"
          size="sm"
          dangerouslySetInnerHTML={{
            __html: t.heroHome.button,
          }}
        />
      </a>

    </div>
  )
}

export default Hero2025
